import {TranslateService} from '@ngx-translate/core';
import {AlertService} from '../widgets/alert/alert.service';

export class AlertUtils {

  public static showAlert(valid: boolean, content: string, translateService: TranslateService, alertService: AlertService): void {
    if (valid) {
      translateService.get(content, {}).subscribe((res: string) => {
        alertService.success(res);
      });
    } else {
      translateService.get(content, {}).subscribe((res: string) => {
        alertService.error(res);
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/shared/AlertUtils.ts